import React, { useState } from 'react';
import { addProductToCustomer } from '../../api';

function AddProductDialog({ customerId, userId, onSave, onCancel, existingProduct }) {
  const [productType, setProductType] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  // Verfügbare Produkttypen basierend auf dem bereits vorhandenen Produkt
  const hasPv = existingProduct && existingProduct.toLowerCase().includes('pv');
  const hasWp = existingProduct && existingProduct.toLowerCase().includes('wp');
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      const data = await addProductToCustomer(userId, customerId, productType);
      
      if (data.success) {
        onSave(data.product);
      } else {
        setError(data.error || 'Fehler beim Hinzufügen des Produkts');
      }
    } catch (err) {
      setError('Netzwerkfehler: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-dialog">
        <h3>Produkt hinzufügen</h3>
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Produkttyp</label>
            <div className="product-options">
              {!hasPv && (
                <button 
                  type="button"
                  className={`product-option ${productType === 'PV' ? 'selected' : ''}`}
                  onClick={() => setProductType('PV')}
                >
                  <span className="product-icon pv-icon">🔆</span>
                  <span>PV-Anlage</span>
                </button>
              )}
              
              {!hasWp && (
                <button 
                  type="button"
                  className={`product-option ${productType === 'WP' ? 'selected' : ''}`}
                  onClick={() => setProductType('WP')}
                >
                  <span className="product-icon wp-icon">🔥</span>
                  <span>Wärmepumpe</span>
                </button>
              )}
              
              {(hasPv && hasWp) && (
                <div className="no-products-available">
                  Alle Produkttypen sind bereits zugewiesen
                </div>
              )}
            </div>
          </div>
          
          <div className="modal-actions">
            <button type="button" onClick={onCancel} className="cancel-button">
              Abbrechen
            </button>
            <button 
              type="submit" 
              disabled={loading || !productType || (hasPv && hasWp)}
            >
              {loading ? 'Wird gespeichert...' : 'Produkt hinzufügen'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddProductDialog;